import DialogComponent from './DialogComponent';

export default DialogComponent;
